import * as React from 'react'

import { ReviewsPageContext } from './ReviewsContextProvider'

export const useReviewsPage = () => {
  return React.useContext(ReviewsPageContext)
}
